export default __webpack_public_path__ + "static/pasckathon3-bf2ddd71d844322630377a24cee8fe09.jpg";